import React, { useEffect, useState } from 'react'

import { Column } from 'primereact/column'
import { useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'
import CentersService from '../../../services/centers/center.service.js'
import useHandlerBasicActions from '../../../utils/hooks/useHandlerBasicActions.js'
import DataTableComp from '../../../components/common/data-table/DataTableComp.jsx'
import CenterTypeLinks from './nav/CenterTypeLinks.tsx'
import CenterSection from './common/CenterSection.tsx'
import AppButton from '../../../component/common/AppButton.tsx'
import AppToolbar from '../../../component/layout/AppToolbar.tsx'
import { Group, Stack } from '@mantine/core'
import EntityDropdown from '../../../component/form/EntityDropdown.tsx'
import AppInput from '../../../component/form/AppInput.tsx'

const Centers = ({ centerType }) => {
  const { formatMessage: msg } = useIntl()

  const navigate = useNavigate()

  // const { centerType: urlCenterType } = useParams();

  const [currentCenterType, setCurrentCenterType] = useState(centerType)
  const [currentFranchiseExit, setCurrentFranchiseExit] = useState(false)

  const [selectedCenter, setSelectedCenter] = useState()

  useEffect(() => {
    setCurrentCenterType(centerType)
  }, [centerType])
  useEffect(() => {
    dataFacade.reload()
  }, [currentCenterType, centerType])

  const dataFacade = useHandlerBasicActions({
    sortFieldInitial: 'name',
    getAll: ({ filter, limit, skip, sort }) =>
      CentersService.getAll({
        centerType: currentCenterType,
        franchiseExit: currentFranchiseExit,
        filter,
        limit,
        skip,
        sort,
      }),
  })

  const pagerOptions = {
    ...dataFacade?.pagerOptions,
    totalRecords: dataFacade?.data?.total,
  }

  const dataTable = (
    <DataTableComp
      loading={dataFacade?.loading}
      pagerOptions={pagerOptions}
      tableOptions={{
        value: dataFacade?.data?.resp,
        dataKey: '_id',
        editMode: 'row',
        selectionMode: 'single',
        selection: selectedCenter,
        rowClassName: (rowData) => ({
          'opacity-50': rowData?.basicData?.franchiseExit,
        }),
        onRowSelect: (e) => {
          setSelectedCenter(e.data)
          navigate(`/app/centers/${e.data._id}/data`)
        },
        ...dataFacade?.sortOptions,
      }}
      columns={[
        <Column
          sortable
          field="basicData.name"
          style={{ width: '20%' }}
          header={msg({ id: 'name' })}
        />,
        <Column
          sortable
          style={{ width: '20%' }}
          field="basicData.zone"
          header={msg({ id: 'zone' })}
        />,
        <Column
          sortable
          style={{ width: '20%' }}
          field="basicData.province"
          header={msg({ id: 'province' })}
        />,
        <Column
          sortable
          style={{ width: '20%' }}
          field="basicData.locality"
          header={msg({ id: 'locality' })}
        />,
        <Column
          sortable
          style={{ width: '15%' }}
          field="basicData.zoneLeader.name"
          align="right"
          header={msg({ id: 'zoneLeader' })}
        />,
        // <Column
        //     field="centerType"
        //     align="right"
        //     header={msg({ id: "centerType" })}
        // />,
        // <Column
        //     field="basicData.franchiseExit"
        //     align="right"
        //     header={msg({ id: "franchiseExit" })}
        //     body={(rowData) => bodyCheckbox(rowData?.basicData?.franchiseExit)}
        // />,
        // canDelete(MODULES.SETTINGS, GROUPS.MUTUAL) && (
        //     <Column
        //         body={(rowData) => DataTableFun.buttonDelete(rowData, dataFacade.remove)}
        //         exportable={false}
        //     />
        // ),
        // canEdit(MODULES.SETTINGS, GROUPS.MUTUAL) && (
        //     <Column
        //         body={buttonEdit}
        //         exportable={false}
        //     />
        // )
      ]}
    />
  )

  return (
    <CenterSection
      header={<CenterTypeLinks />}
      // subheader={[<AppToolbar leftSection={[<Group>OK</Group>]} />]}
      toolbar={
        <AppToolbar
          dataFacade={dataFacade}
          rightSection={[
            <AppButton
              preset="add"
              onClick={() =>
                navigate(
                  `/app/centers/undefined/data${currentCenterType ? '?&centerType=' + currentCenterType : ''}`,
                )
              }
            />,
          ]}
        />
      }
    >
      {dataTable}
    </CenterSection>
  )
}

export default Centers
